import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

//actions
import { getEarningChartsData } from "../../store/actions";

import ReactApexChart from "react-apexcharts";

class Earning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        {
          name: "1",
          // Randome Array of 31 numbers
          data: [31, 40, 36, 51, 49, 72, 68, 76, 78, 51, 49, 72, 69],
        },
      ],
      options: {
        maintainAspectRatio: false,
        labels: ["Verified Labs", "Unverified Labs"],
        colors: ["#556ee6", "#f46a6a"],
        legend: { show: !1 },
        plotOptions: {
          pie: {
            donut: {
              size: "60%",
            },
          },
        },
      },
      earningChartData: [],
      values:[],
      seletedMonth: "jan",
    };
  }

  componentDidMount() {
    const { onGetEarningChartsData } = this.props;
    onGetEarningChartsData("jan");
    const{values}=this.props.values
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        ...this.state,
        earningChartData: this.props.earningChartData,
        values:this.props.values
      });
    }
  }

  render() {
    const { earningChartData, seletedMonth } = this.state;

    const series = [
      {
        name: "Sales Ammount :",
        data: [...earningChartData],
      },
    ];
    return (
      <React.Fragment>
        <Col xl="8">
          <Card>
            <CardBody>
              <div className="clearfix">
                <div className="float-end">
                  <div className="input-group input-group-sm">
                    <label className="input-group-text">Total Users</label>
                  </div>
                </div>
                <h4 className="card-title mb-4 text-center">User Statistics</h4>
              </div>

              <Row>
               
                  <div className="text-muted">
                    <div className="mb-3">
                      <p>Total Users</p>
                      <h4> {this.state.values[0]}</h4>
                      
                    </div>
                    </div>
                    
                    <Row>
                    <div className="mb-3">
                      <p>Unverified Users</p>
                      <h4> {this.state.values[1]}</h4>                      
                    </div>
                    <div className="mb-3">
                      <p>Verified Users</p>
                      <h4> {this.state.values[2]}</h4>                      
                    </div>
                    </Row>

                <Col lg="8">
                  {/* <div id="line-chart" className="apex-charts" dir="ltr">
                    <ReactApexChart
                      series={[this.props.values[3], this.props.values[4]]}
                      options={this.state.options}
                      type="donut"
                      height={250}
                      className="apex-charts"

                    />
                  </div> */}

                </Col>
                <div className="text-center text-muted">
                <Row>
                  <Col xs="4">
                    <div className="mt-4">
                      <p className="mb-2 text-truncate">
                        <i className="mdi mdi-circle text-primary me-1"/>
                        Male
                      </p>
                      <h5>Total: {this.props.values[3]}</h5>
                    </div>
                  </Col>
                  <Col xs="4">

                  </Col>
                  <Col xs="4">
                    <div className="mt-4">
                      <p className="mb-2 text-truncate">
                        <i className="mdi mdi-circle text-danger me-1"/>
                        Female
                      </p>
                      <h5>Total: {this.props.values[4]}</h5>
                    </div>
                  </Col>
                </Row>
              </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </React.Fragment>
    );
  }
}

Earning.propTypes = {
  earningChartData: PropTypes.any,
  onGetEarningChartsData: PropTypes.func,
  values:PropTypes.array
};

const mapStateToProps = ({ DashboardSaas }) => ({
  earningChartData: DashboardSaas.earningChartData,
});

const mapDispatchToProps = dispatch => ({
  onGetEarningChartsData: month => dispatch(getEarningChartsData(month)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Earning);
